import { render } from "./SiteHero.vue?vue&type=template&id=df27bf3e&scoped=true"
import script from "./SiteHero.vue?vue&type=script&lang=js"
export * from "./SiteHero.vue?vue&type=script&lang=js"

import "./SiteHero.vue?vue&type=style&index=0&id=df27bf3e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-df27bf3e"]])

export default __exports__